import { FormEvent } from "react";
import Cleave from "cleave.js/react";
import { useSubmit } from "react-router-dom";

import Modal from "src/components/common/Modal";

type Props = {
    closeIt: () => void;
};

export default function OutsideDivisionForm({ closeIt }: Props) {
    const submit = useSubmit();

    return (
        <Modal
            closeIt = {closeIt}
            title = {"Outside Division Form"}
            width = {"40rem"}
            actionKey = {"Submit"}
            handleFormSubmit = {(e: FormEvent<HTMLFormElement>) => {
                const form = e.currentTarget;
                const formData = new FormData(form);
                formData.append("intent", "create");
                submit(formData, { method: "post" });
                closeIt();
            }}
        >
            <div className = "d-flex align-items-center mt-2">
                <label htmlFor = "divisionInput" className = "fw-bold">Division:</label>
                <input
                    id = "divisionInput"
                    required
                    type = "text"
                    className = "form-control flex-grow-1 ms-3"
                    name = "division"
                    defaultValue = {""}
                />
            </div>
            <div className = "d-flex align-items-center mt-2">
                <label htmlFor = "supervisorNameInput" className = "fw-bold me-3">Supervisor Name:</label>
                <input
                    id = "supervisorNameInput"
                    type = "text"
                    className = "form-control flex-grow-1 ms-3"
                    name = "supervisorName"
                    defaultValue = {""}
                />
            </div>
            <div className = "d-flex align-items-center mt-2">
                <label htmlFor = "supervisorEmailInput" className = "fw-bold me-3">Supervisor Email:</label>
                <input
                    id = "supervisorEmailInput"
                    type = "email"
                    className = "form-control flex-grow-1 ms-3"
                    name = "supervisorEmail"
                    defaultValue = {""}
                />
            </div>
            <div className = "d-flex align-items-center mt-2">
                <label htmlFor = "roleInput" className = "fw-bold mb-0">Role:</label>
                <input
                    id = "roleInput"
                    type = "text"
                    className = "form-control flex-grow-1 ms-3"
                    name = "role"
                    defaultValue = {""}
                />
            </div>
            <div className = "d-flex align-items-center mt-2">
                <label htmlFor = "supervisorPhoneInput" className = "fw-bold mb-0">Supervisor Phone:</label>
                <Cleave
                    id = "supervisorPhoneInput"
                    className = "form-control flex-grow-1 ms-3"
                    name = "supervisorPhone"
                    pattern = "[0-9]{3}-[0-9]{3}-[0-9]{4}|$^"
                    options = {{
                        blocks: [3, 3, 4],
                        delimiter: "-",
                        numericOnly: true,
                    }}
                    defaultValue = {""}
                />
            </div>
            <div className = "d-flex align-items-center mt-2 mb-2">
                <label htmlFor = "regionInput" className = "fw-bold mb-0">Region:</label>
                <input
                    id = "regionInput"
                    type = "text"
                    className = "form-control flex-grow-1 ms-3"
                    name = "region"
                    defaultValue = {""}
                />
            </div>
        </Modal>
    );
}
